export default "__VITE_ASSET__DHCciun___"